<template>
	<div class="bottom_button" :style="computedStyle" @click="$_handleBackward">
		<c-icon name="IconBackwardLargeLine" size="large" color="gray500" />
	</div>
</template>

<script>
import searchMixin from '../../../mixins/searchMixin';
import { mapGetters } from 'vuex';

export default {
	name: 'BackwardButton',
	mixins: [searchMixin],
	computed: {
		...mapGetters('layoutStore', ['backwardButtonMarginBottom']),
		computedStyle() {
			return { marginBottom: this.backwardButtonMarginBottom };
		},
	},
};
</script>

<style lang="scss" scoped>
@import '../../../../scss/base/main';

.bottom_button {
	background: $white;
	@include shadow1();
	@include border-radius(6px);
	width: 40px;
	height: 40px;
	padding: 8px;
	position: fixed;
	left: 0;
	bottom: 0;
	margin-left: 16px;
	margin-bottom: 16px;
	z-index: 10;
}
</style>
